module.exports = __webpack_public_path__ + "static/media/c71-wifi.3b6d595d.png";